document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.bundle-wrapper');
  if (!wrapper) return;

  const boxes = wrapper.querySelectorAll('.bundle-box');
  if (boxes.length <= 1) return;

  const dots = wrapper.querySelectorAll('.bundle-dot');
  const prevBtn = wrapper.querySelector('#bundle-prev');
  const nextBtn = wrapper.querySelector('#bundle-next');
  let current = 0;

  function goTo(index) {
    boxes[current].style.display = 'none';
    dots[current].classList.remove('active');
    current = (index + boxes.length) % boxes.length;
    boxes[current].style.display = 'block';
    dots[current].classList.add('active');
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { goTo(i); });
  });
});